import { queryOptions } from "@tanstack/react-query";
import { REVIEW_QUERY_KEYS } from "./keys";
import { reviewAPIClient } from "../reviewAPIClient";
import type {
  GetProductReviewsRequest,
  GetProductReviewsResponse,
  GetCuratedReviewsResponse,
  ReviewStatisticsRequest,
  ReviewStatisticsResponse,
} from "./types";

export const REVIEW_QUERIES = {
  getProductReviews: (
    productId: number,
    params?: Omit<GetProductReviewsRequest, "productId">,
  ) =>
    queryOptions<GetProductReviewsResponse>({
      queryKey: REVIEW_QUERY_KEYS.getProductReviews(productId, params),
      queryFn: () => reviewAPIClient.getProductReviews(productId, params),
    }),

  getCuratedReviews: () =>
    queryOptions<GetCuratedReviewsResponse>({
      queryKey: REVIEW_QUERY_KEYS.getCuratedReviews(),
      queryFn: () => reviewAPIClient.getCuratedReviews(),
    }),

  getReviewStatistics: (params: ReviewStatisticsRequest) =>
    queryOptions<ReviewStatisticsResponse>({
      queryKey: REVIEW_QUERY_KEYS.getReviewStatistics(params),
      queryFn: () => reviewAPIClient.getReviewStatistics(params),
    }),
};
